import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Langs, { Localize } from '../../app/lang/langs';
import { getManagersList } from '../../components/permissions/permissionsSlice';
import pStyles from './Permissions.module.css';

export default function CollabsManagersTab() {
    let dispatch = useDispatch()
    let managersList = useSelector((state) => state.permissions.managersList)

    let [globalFilter, setGlobalFilter] = useState('')

    useEffect(() => {
        dispatch(getManagersList({}))
    }, [dispatch])

    const managersWithFullName = managersList.map((m) => ({
        ...m,
        fullName: `${m.prenom ?? ''} ${m.nom ?? ''}`.trim(),
    }))

    let collabTemplate = (rowData) => {
        return `${rowData.prenom} ${rowData.nom}`
    }

    let profileSeverity = (profileName) => {
        switch (profileName?.toLowerCase()) {
            case 'manager': return 'warning'
            case 'sdm': return 'info'
            case 'responscompte': return 'success'
            default: return 'warning'
        }
    }

    let profileTemplate = (rowData) => {
        return <Tag value={rowData.profile_name} severity={profileSeverity(rowData.profile_name)} />
    }

    let header = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 0' }}>
            <TextField
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder={Localize('SEARCH')}
                size="small"
                sx={{ width: 260 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ fontSize: 20, color: 'rgba(0,40,128,0.4)' }} />
                        </InputAdornment>
                    ),
                }}
            />
        </div>
    )

    return (
        <div className={`profile-mgmt-card ${pStyles.profileCard}`}>
            <div className={pStyles.infoBanner}>
                <InfoOutlinedIcon sx={{ fontSize: 18, color: 'rgba(0,40,128,0.5)' }} />
                <span><Langs str="TEAMS_OVERVIEW_INFO" /></span>
            </div>
            <DataTable
                value={managersWithFullName}
                dataKey="id"
                header={header}
                globalFilter={globalFilter}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                emptyMessage={Localize('NO_RESULTS')}
                scrollable
                scrollHeight="calc(100vh - 380px)"
                style={{ borderRadius: 14, overflow: 'hidden' }}
            >
                <Column field="fullName" header={Localize('COLLAB')} body={collabTemplate} sortable sortField="prenom" filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '12rem' }} />
                <Column field="email" header="Email" sortable filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '14rem' }} />
                <Column field="matricule" header={Localize('MATRICULE')} sortable filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '8rem' }} />
                <Column field="team_name" header={Localize('TEAM')} sortable filter filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '10rem' }} />
                <Column header={Localize('PROFILE')} body={profileTemplate} sortable sortField="profile_name" filter filterField="profile_name" filterPlaceholder={Localize('SEARCH')} style={{ minWidth: '8rem' }} />
            </DataTable>
        </div>
    )
}
